import React, { FC } from 'react'
import * as Styled from './styles'
import { CSSProperties } from 'styled-components'

export const HpxCard: FC<{
  step?: string
  split?: boolean
  leftSection?: React.ReactNode
  rightSection?: React.ReactNode
  useMediaQuery?: boolean
  isHpxVPDesign?: boolean
  customProps?: CSSProperties
}> = ({
  step,
  split,
  leftSection,
  rightSection,
  children,
  useMediaQuery,
  isHpxVPDesign,
  customProps
}) => {
  let padding: string

  switch (step) {
    case 'afu':
    case 'oobe-vp':
      padding = '32px'
      break
    case 'connect':
      padding = '48px 32px 32px'
      break
    default:
      padding = '56px 32px'
      break
  }

  padding = split ? '0' : padding

  if (split) {
    return (
      <Styled.HpxCard
        $padding={padding}
        $splitCard={split}
        $step={step}
        $customProps={customProps}
      >
        <Styled.ContentContainer $useMediaQuery={useMediaQuery}>
          <Styled.LeftSection>{leftSection}</Styled.LeftSection>
          <Styled.RightSection>{rightSection}</Styled.RightSection>
        </Styled.ContentContainer>
      </Styled.HpxCard>
    )
  }

  return (
    <Styled.HpxCard
      $padding={padding}
      $splitCard={split}
      $step={step}
      $isHpxVPDesign={isHpxVPDesign}
      $customProps={customProps}
    >
      {children}
    </Styled.HpxCard>
  )
}
